import { render } from "./CustomersList.vue?vue&type=template&id=02e599e2&scoped=true&ts=true"
import script from "./CustomersList.vue?vue&type=script&lang=ts"
export * from "./CustomersList.vue?vue&type=script&lang=ts"

import "./CustomersList.vue?vue&type=style&index=0&id=02e599e2&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web-staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02e599e2"]])

export default __exports__